import base64 from 'base-64'
const location = window.location.href
const environment = process.env.NODE_ENV;
const orgUrl = location.indexOf("identityservices-deprecated.mycargill.com") > -1 ? process.env.CUSTOM_ORG_URL : process.env.ORG_URL;
const client = process.env.KEY_ID;
const mmClient = process.env.MM_CLIENT_ID;
let brandDetails = "";
console.log('env=====', environment);
if (environment === 'production') {
  brandDetails = require('../brand-details.json');
} else if (environment === 'stage') {
  brandDetails = require('../brand-details-stage.json');
} else {
  brandDetails = require('../brand-details-dev.json');
}
let brand = brandDetails.data.filter(i => i.applicationUrls.indexOf(document.location.host) > -1)

export default {
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  getBrowserLanguage: function(language) {
    language = language.split("-")[0]
    let currLang = ""
    if (language.indexOf('nl') > -1) {
      currLang = "nl-NL";
    } else if (language.indexOf('pt') > -1) {
      currLang = "pt-BR";
    } else if (language.indexOf('zh') > -1) {
      if (language.indexOf('zh_CN')) {
        currLang = "zh-CN";
      } else {
        currLang = "zh-TW";
      }
    } else {
      currLang = language
    }
    return currLang
  },
  getConfig: function() {
    let clientid = client;
    let issuer = orgUrl + ((location.indexOf("identityservices-deprecated.mycargill.com") > -1) ? 'oauth2/aus8t2pqucPuufOY00i7' : 'oauth2/aus6b7mr2cT6LwRXO0i7');
    let redirectUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + '/login/callback'; // process.env.LOGIN_REDIRECT_URL;
    let responseType = ['id_token', 'token'];
    let scope = ['identity.api.default', 'openid', 'email', 'profile'];
    let pkce = true;
    console.log(base64.encode(mmClient))
    const host = this.getParameterByName('id', location)
    const env = this.getParameterByName('env', location)
    let mmRedirect = process.env.MM_REDIRECT_URL;
    if ((location.indexOf("identityservices-deprecated.mycargill.com") > -1) && host && base64.decode(host) === mmClient) {
      if (env) {
        if (environment === 'stage' && env.toLowerCase() === 'sandbox') {
          mmRedirect = process.env.MM_REDIRECT_URL_SANDBOX
        } else if (environment === 'stage' && env.toLowerCase() === 'dev') {
          mmRedirect = process.env.MM_REDIRECT_URL_DEV
        } else {
          window.location = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + '/Error?app=milkMoovement';
        }
      }
      brand[0].isEmployeeLoginRequired = false
      clientid = mmClient;
      issuer = orgUrl + 'oauth2/aus7560izdyHixyCz0i7'
      redirectUrl = mmRedirect;
      scope = ['milkmoovement.api.default', 'openid', 'offline_access']
      responseType = 'code'
      pkce = false
    }
    if (location.indexOf('action=unlock') > -1) {
      brand[0].isEmployeeLoginRequired = false
    }
    const oktaConfig = {
      clientId: clientid,
      issuer: issuer,
      redirectUrl: redirectUrl,
      scopes: scope,
      responseType: responseType,
      pkce: pkce,
      host: host,
      mmclient: mmClient
    }
    return oktaConfig;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/okta-config.js